import { render, staticRenderFns } from "./TimelineItemForm.vue?vue&type=template&id=dd2157d2&scoped=true"
import script from "./TimelineItemForm.vue?vue&type=script&lang=ts"
export * from "./TimelineItemForm.vue?vue&type=script&lang=ts"
import style0 from "./TimelineItemForm.vue?vue&type=style&index=0&id=dd2157d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2157d2",
  null
  
)

export default component.exports